import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

// Compagnie dell'agenzia, solo se il plurimandato è attivo (altrimenti lista vuota).
export function useCompanies() {
  const { user } = useAuth();
  const enabled = !!user?.agency?.plurimandatari_abilitato;
  const [companies, setCompanies] = useState([]);
  useEffect(() => {
    if (!enabled) { setCompanies([]); return; }
    api.get("/companies").then((r) => setCompanies(r.data || [])).catch(() => setCompanies([]));
  }, [enabled]);
  return companies;
}

export const CompagniaFilter = ({ value, onChange, testId = "filter-compagnia", className = "" }) => {
  const companies = useCompanies();
  if (!companies.length) return null;
  return (
    <div className={className}>
      <Label>Compagnia</Label>
      <Select value={value || "all"} onValueChange={(v) => onChange(v === "all" ? "" : v)}>
        <SelectTrigger data-testid={testId}><SelectValue placeholder="Tutte" /></SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Tutte</SelectItem>
          {companies.map((c) => <SelectItem key={c.id} value={c.id}>{c.nome}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
};
